import { Component, HostBinding, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'eui-card-footer-action-icons',
    templateUrl: './eui-card-footer-action-icons.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EuiCardFooterActionIconsComponent {

    @HostBinding('class') string = 'eui-card-footer-actions__icons';

    constructor() {
    }
}
